/**
 * Extracts a filename from a Content-Disposition header value.
 * Supports both `filename*=UTF-8''...` and `filename="..."` formats.
 *
 * @param {string|null} contentDisposition - Raw header value
 * @returns {string|null} Decoded filename or null when not present
 */
export const parseFilenameFromContentDisposition = (contentDisposition) => {
  if (!contentDisposition) return null

  const encodedMatch = contentDisposition.match(/filename\*=(?:UTF-8'')?([^;]+)/i)
  if (encodedMatch?.[1]) {
    try {
      return decodeURIComponent(
        encodedMatch[1].trim().replace(/^["']|["']$/g, ''),
      )
    } catch {
      // Fall through to the plain filename format.
    }
  }

  const plainMatch = contentDisposition.match(/filename="?([^";]+)"?/i)

  return plainMatch?.[1]?.trim() || null
}
